import { render, staticRenderFns } from "./VMobileNavItem.vue?vue&type=template&id=57beaf4b&"
import script from "./VMobileNavItem.vue?vue&type=script&lang=js&"
export * from "./VMobileNavItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports